<template>
  <CockpitDialog :title="`${title}详情`" @close="() => $emit('close')">
    <!-- 服务器 || 交换机-->
    <div
      v-if="deviceType === 'computer' || deviceType === 'exchangeBoard'"
      class="w-full h-full overflow-x-hidden"
    >
      <el-form :model="formData">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in computerLabels" :key="index" :span="8">
            <el-form-item :label="item.label">
              <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                {{ formData[item.prop] }}
              </div>
              <div v-else class="text-hex-fff">暂无数据</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="flex justify-between items-center mb-10px" v-if="title !== '交换机'">
        <TableButtonGroup
          :list="timeBtnList"
          v-model="timeBtn"
          @btn-click="timeBtnClick"
          :disabledList="[]"
        />
        <div>
          <el-select
            v-model="computerDate"
            size="small"
            popper-class="visualization-select-popper"
            @change="dateChange"
          >
            <el-option
              v-for="item in computerDateList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="h-[calc(100%-226px)] overflow-hidden" v-if="title !== '交换机'">
        <v-chart
          :options="computerOption"
          :autoresize="true"
          class="!h-full !w-full"
          :init-options="{ devicePixelRatio: 2 }"
        ></v-chart>
      </div>
    </div>
    <!-- 定位基站 -->
    <div v-else-if="deviceType === 'positionStation'" class="w-full h-full overflow-x-hidden">
      <el-form :model="formData">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in locationLabels" :key="index" :span="item.col || 12">
            <el-form-item :label="item.label">
              <div v-if="item.type === 'date'" class="truncate text-hex-fff">
                <span v-if="formData[item.prop]">
                  {{ dayjs(formData[item.prop]).format('YYYY-MM-DD HH:mm:ss') }}
                </span>
                <span v-else>暂无数据</span>
              </div>
              <template v-else>
                <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                  {{ formData[item.prop] }}
                </div>
                <div v-else class="text-hex-fff">暂无数据</div>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 门禁 -->
    <div v-else-if="deviceType === 'access'">
      <el-form :model="formData" class="w-full h-full overflow-x-hidden">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in doorLabels" :key="index" :span="item.col || 8">
            <el-form-item :label="item.label">
              <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                {{ formData[item.prop] }}
              </div>
              <div v-else class="text-hex-fff">暂无数据</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 摄像头 -->
    <div v-else-if="deviceType === 'camera'">
      <el-form :model="formData" class="w-full h-full overflow-x-hidden">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in cameraLabels" :key="index" :span="item.col || 8">
            <el-form-item :label="item.label">
              <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                {{ formData[item.prop] }}
              </div>
              <div v-else class="text-hex-fff">暂无数据</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 5G基站 通信基站 -->
    <div v-else-if="deviceType === 'communicationStation'" class="w-full h-full">
      <el-form :model="formData" class="w-full h-full overflow-x-hidden">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in communicationLabels" :key="index" :span="item.col || 8">
            <el-form-item :label="item.label">
              <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                {{ formData[item.prop] }}
              </div>
              <div v-else class="text-hex-fff">暂无数据</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 机柜 -->
    <div v-else-if="deviceType === 'rack'" class="w-full h-full">
      <el-form :model="formData" class="w-full">
        <el-row :gutter="15" class="w-full h-full overflow-auto">
          <el-col v-for="(item, index) in cabinetLabels" :key="index" :span="item.col || 8">
            <el-form-item :label="item.label">
              <div class="truncate text-hex-fff" v-if="formData[item.prop]">
                {{ formData[item.prop] }}
              </div>
              <div v-else class="text-hex-fff">暂无数据</div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <TableButtonGroup
        :list="cabinetBtnList"
        v-model="cabinetBtn"
        @btn-click="cabinetBtnClick"
        :disabledList="[]"
      />
      <div class="mt-20px h-[calc(100%-106px)]">
        <div class="w-full h-full overflow-x-hidden" v-if="cabinetBtn === '机架式空调'">
          <el-collapse v-model="activeNames">
            <el-collapse-item title="总体信息" name="1">
              <el-table :data="hvacTableData" highlight-current-row height="90">
                <el-table-column label="送风温度(°C)" prop="airSupplyTem"></el-table-column>
                <el-table-column label="回风温度(°C)" prop="returnTem"></el-table-column>
                <el-table-column label="送风湿度(%)" prop="airSupplyHum"></el-table-column>
                <el-table-column label="回风湿度(%)" prop="returnHum"></el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item title="详细信息" name="2">
              <el-form :model="formData" class="w-full">
                <el-row :gutter="15" class="w-full h-full overflow-auto">
                  <el-col
                    v-for="(item, index) in hvacFormLabels"
                    :key="index"
                    :span="item.col || 8"
                  >
                    <el-form-item :label="`${item.label}${item.unit} :`">
                      <div class="truncate text-hex-fff" v-if="item.value">
                        {{ item.value }}
                      </div>
                      <div v-else class="text-hex-fff">暂无数据</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-else-if="cabinetBtn === '物联锁'" class="w-full h-full overflow-x-hidden">
          <el-table :data="IOTinterlockingTableData" highlight-current-row height="100%">
            <el-table-column label="设备类型" prop="deviceType"></el-table-column>
            <el-table-column label="通讯状态" prop="commStatus"></el-table-column>
            <el-table-column label="锁状态" prop="lockStatus"></el-table-column>
          </el-table>
        </div>
        <div v-else-if="cabinetBtn === '远程输入量开关'" class="w-full h-full overflow-x-hidden">
          <el-table :data="remoteInputSwitchTableData" highlight-current-row height="100%">
            <el-table-column label="名称" prop="name"></el-table-column>
            <el-table-column label="状态" prop="status"></el-table-column>
          </el-table>
        </div>
        <div v-else-if="cabinetBtn === '配电监控系统'" class="w-full h-full overflow-x-hidden">
          <el-collapse v-model="DMSysActiveNames">
            <el-collapse-item title="配电拓扑" name="1">
              <el-table
                :data="PDTtableData"
                :span-method="objectSpanMethod"
                highlight-current-row
                height="170"
                class="pdt-table"
              >
                <el-table-column label="电压(v)" prop="voltage"></el-table-column>
                <el-table-column label="电流(v)" prop="electricity"></el-table-column>
                <el-table-column label="有功功率(kW)" prop="power"></el-table-column>
                <el-table-column label="电能(kWh)" prop="energy"></el-table-column>
              </el-table>
            </el-collapse-item>
            <el-collapse-item title="详细信息" name="2">
              <el-form :model="PDFormData" class="w-full">
                <el-row :gutter="15" class="w-full h-full overflow-auto">
                  <el-col v-for="(item, index) in PDTFormLabels" :key="index" :span="item.col || 8">
                    <el-form-item :label="`${item.label} :`">
                      <div class="truncate text-hex-fff" v-if="item.value">{{ item.value }}</div>
                      <div v-else class="text-hex-fff">暂无数据</div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div v-else-if="cabinetBtn === '温湿度'" class="w-full h-full overflow-x-hidden">
          <el-table :data="THtableData" highlight-current-row height="100%">
            <el-table-column label="设备名称" prop="name"></el-table-column>
            <el-table-column label="温度(°C)" prop="tem"></el-table-column>
            <el-table-column label="湿度(%RH)" prop="hum"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </CockpitDialog>
</template>

<script>
// tools
import { cloneDeep, get, includes } from 'lodash'
import dayjs from 'dayjs'
// components
import CockpitDialog from '@/components/cockpit/CockpitDialog'
import TableButtonGroup from '@/components/cockpit/TableButtonGroup'
// api
import { ServerApi, MeasuringPointApi } from '@wiz-api/huizhou2-business'

import { isJSONObj } from '@/modules/visualization-cockpit/assets/js/scene/scene'
import { lineOption } from '../ChartsOptions'

const serverApi = new ServerApi()
const measuringPointApi = new MeasuringPointApi()

export default {
  data() {
    return {
      formData: {},
      // 服务器
      computerDate: '30分钟',
      computerDateList: [
        { label: '30分钟', value: '30分钟' },
        { label: '6小时', value: '6小时' },
        { label: '1天', value: '1天' },
        { label: '7天', value: '7天' },
      ],
      computerLabels: [
        { label: '设备名称: ', prop: 'name' },
        { label: '设备型号: ', prop: 'model' },
        { label: '设备厂家: ', prop: 'factory' },
        { label: 'IP地址: ', prop: 'ip' },
        { label: '操作系统: ', prop: 'os' },
        { label: 'CPU: ', prop: 'cpu' },
        { label: '物理内存: ', prop: 'physicalMemory' },
        { label: '磁盘: ', prop: 'hardDisk' },
      ],
      serveData: {},
      timeBtnList: ['CPU趋势', '内存趋势', '平均负荷趋势', 'IO速率趋势'],
      timeBtn: 'CPU趋势',
      computerOption: cloneDeep(lineOption),
      // 定位基站
      locationLabels: [
        { label: '设备名称: ', prop: 'name' },
        { label: 'IP地址: ', prop: 'ip' },
        { label: '编码: ', prop: 'code' },
        { label: '安装日期: ', prop: 'installDate', type: 'date' },
        { label: '制造商: ', prop: 'facotry' },
        { label: '产品型号: ', prop: 'model' },
        { label: '是否在线: ', prop: 'status' },
        { label: '位置坐标: ', prop: 'position', col: 24 },
      ],
      locationData: {},
      // 门禁
      doorLabels: [
        { label: '设备名称: ', prop: 'name', col: 24 },
        { label: '设备编码: ', prop: 'code', col: 24 },
        { label: '运行状态: ', prop: 'statusText', col: 24 },
        { label: '设备厂商: ', prop: 'facturer', col: 24 },
      ],
      // 摄像头
      cameraLabels: [
        { label: '设备名称: ', prop: 'name', col: 24 },
        { label: '设备编码: ', prop: 'code', col: 24 },
        { label: '设备厂商: ', prop: 'facturer', col: 24 },
        { label: '运行状态 ', prop: 'statusText', col: 24 },
      ],
      // 机柜
      cabinetLabels: [
        { label: '设备名称: ', prop: 'name' },
        { label: '厂家: ', prop: 'code' },
        { label: '设备型号: ', prop: 'model' },
      ],
      cabinetBtnList: ['配电监控系统', '物联锁', '远程输入量开关', '温湿度', '机架式空调'],
      cabinetBtn: '配电监控系统',
      hvacTableData: [
        {
          airSupplyTem: '',
          returnTem: '',
          airSupplyHum: '',
          returnHum: '',
          airSupplyTemProp: '送风温度',
          returnTemProp: '回风温度',
          airSupplyHumProp: '送风湿度',
          returnHumProp: '回风湿度',
        },
      ],
      IOTinterlockingTableData: [], // 物联锁table
      remoteInputSwitchTableData: [], // 远程输入量开关table
      PDTtableData: [
        {
          voltageProp: '电压1',
          electricityProp: '电流1',
          powerProp: '有功功率1',
          voltage: '',
          electricity: '',
          power: '',
          energyProp: '电能',
          energy: '',
        },
        {
          voltageProp: '电压2',
          electricityProp: '电流2',
          powerProp: '有功功率2',
          energyProp: '',
          voltage: '',
          electricity: '',
          power: '',
          energy: '',
        },
        {
          voltageProp: '电压3',
          electricityProp: '电流3',
          powerProp: '有功功率3',
          energyProp: '',
          voltage: '',
          electricity: '',
          power: '',
          energy: '',
        },
      ], // 配电监控系统
      THtableData: [], // 温湿度table
      activeNames: ['1', '2'],
      DMSysActiveNames: ['1', '2'],
      hvacFormLabels: [
        { label: '外风机转速', unit: '(%)', value: '' },
        { label: '压机运行频率', unit: '(Hz)', value: '' },
        { label: '内风机控制转速', unit: '(%)', value: '' },
        { label: '机组累计运行时间', unit: '(h)', value: '' },
        { label: '电源电压', unit: '(V)', value: '' },
        { label: '平均温度', unit: '(°C)', value: '' },
      ],
      PDTFormLabels: [
        { label: '送风高温报警', value: '' },
        { label: '滤网堵塞报警', value: '' },
        { label: '系统压力传感器故障', value: '' },
        { label: '风机过载故障', value: '' },
        { label: '高温报警', value: '' },
        { label: '排气温度过高', value: '' },
      ],
      PDFormData: {},
      // 通信基站
      communicationLabels: [
        { label: '设备名称', prop: 'name' },
        { label: '设备编号', prop: 'code' },
        { label: '厂家', prop: 'factory' },
        { label: 'RRU名称', prop: 'rruName' },
        { label: 'GM小区名称', prop: 'gmName' },
        { label: 'NR小区标识', prop: 'nrName' },
        { label: 'CellID', prop: 'cellID' },
        { label: '网络模式', prop: 'netWorkType' },
        { label: '制式', prop: 'standard' },
        { label: '频段', prop: 'band' },
        { label: '频点', prop: 'frequency' },
        { label: 'SSB频点', prop: 'ssbFrequency' },
        { label: 'GSCN', prop: 'gcn' },
        { label: '物理小区标', prop: 'physicalCellMark' },
        { label: '根序列', prop: 'rootSequence' },
        { label: '小区状态', prop: 'cellStatus' },
        { label: '行政区', prop: 'district' },
        { label: '镇区', prop: 'townShip' },
        { label: '站点位置', prop: 'position' },
      ],
      page: {
        pageSize: 1,
        pageNo: 15,
        total: 0,
      },
      dateObj: {
        '30分钟': '30m',
        '6小时': '6h',
        '1天': '1d',
        '7天': '7d',
      },
      dateFormatObj: {
        '30m': 'HH:mm',
        '6h': 'HH:mm',
        '1d': 'MM-DD HH:mm',
        '7d': 'MM-DD',
      },
      apiObj: {
        CPU趋势: 'getServerCpuMetric',
        内存趋势: 'getServerMemoryMetric',
        IO速率趋势: 'getServerIOMetric',
        平均负荷趋势: 'getServerNetMetric',
      },
    }
  },
  methods: {
    objectSpanMethod({ columnIndex }) {
      if (columnIndex === 3) {
        return {
          rowspan: 3,
          colspan: 1,
        }
      }
      return {
        rowspan: 1,
        colspan: 1,
      }
    },
    // 获取机柜设备数据
    async getCabinetData() {
      const [err, res] = await measuringPointApi.getServerCpuMetric({
        deviceId: this.detailData.id,
        componentName: this.cabinetBtn,
      })
      if (!err && res) {
        switch (this.cabinetBtn) {
          case '配电监控系统':
            this.PDTtableData = this.PDTtableData.map((it) => {
              res.forEach((item) => {
                switch (item.componentName) {
                  case it.voltageProp:
                    it.voltage = item.value
                    break
                  case it.electricityProp:
                    it.electricity = item.value
                    break
                  case it.powerProp:
                    it.power = item.value
                    break
                  case it.energyProp:
                    it.energy = item.value
                    break
                  default:
                    break
                }
                // 组装form
                this.PDTFormLabels.forEach((i) => {
                  if (item.componentName === i.label) {
                    i.value = item.value === 0 ? '正常' : '报警/故障'
                  }
                })
              })
              return it
            })
            break
          case '物联锁':
            this.IOTinterlockingTableData = res.map((it) => {
              const type = it.measuringPointName.split('-')
              it.deviceType = type[type.length - 2]
              it.lockStatus = type[type.length - 1] === 0 ? '已上锁' : '已开锁'
              it.commStatus = it.value === 0 ? '通讯正常' : '通讯异常'
              return it
            })
            break
          case '远程输入量开关':
            this.remoteInputSwitchTableData = res.map((it) => {
              const type = it.measuringPointName.split('-')
              it.name = type[type.length - 2]
              it.status = it.value === 0 ? '正常' : '异常'
              return it
            })
            break
          case '温湿度':
            const addArrItem = res.map((it) => {
              const name = it.measuringPointName.split('-')
              it.deviceName = name[name.length - 2]
              return it
            })
            // 一维数组转二维 组装table
            this.THtableData = Object.values(
              addArrItem.reduce((prev, cur) => {
                prev[cur.deviceName]
                  ? prev[cur.deviceName].push(cur)
                  : (prev[cur.deviceName] = [cur])
                return prev
              }, {})
            ).map((it) => {
              const params = { name: '', tem: '', hum: '' }
              it.forEach((i) => {
                params.name = i.deviceName
                if (i.componentName === '温度') params.tem = i.value
                if (i.componentName === '湿度') params.hum = i.value
              })
              return params
            })
            break
          case '机架式空调':
            this.hvacTableData = this.hvacTableData.map((it) => {
              res.forEach((item) => {
                switch (item.componentName) {
                  case it.airSupplyTemProp:
                    it.airSupplyTem = item.value
                    break
                  case it.returnTemProp:
                    it.returnTem = item.value
                    break
                  case it.airSupplyHumProp:
                    it.airSupplyHum = item.value
                    break
                  case it.returnHumProp:
                    it.returnHum = item.value
                    break
                  default:
                    break
                }
                // 组装form
                this.hvacFormLabels.forEach((i) => {
                  if (item.componentName === i.label) i.value = item.value
                })
              })
              return it
            })
            break
          default:
            break
        }
      }
    },
    // 获取服务器Echarts数据
    async getEchartsData(name) {
      if (this.title === '交换机') return
      const tiemgap = this.dateObj[this.computerDate]
      const params = {
        objectId: this.detailData.id,
        objectType: 'host',
        tiemgap,
      }
      const [err, res] = await serverApi[this.apiObj[name]](params)
      if (!err) {
        this.computerOption.xAxis.data = res.datapoints.map((it) => {
          return dayjs(it[0]).format(this.dateFormatObj[tiemgap])
        })
        this.computerOption.series[0].data = res.datapoints.map((it) => {
          return it[1]
        })
      }
    },
    cabinetBtnClick() {
      this.getCabinetData()
    },
    dateChange() {
      this.getEchartsData(this.timeBtn)
    },
    // 切换测点时间
    timeBtnClick(val) {
      this.getEchartsData(val)
      switch (val) {
        case 'CPU趋势':
          this.computerOption.color = ['#44f1ff']
          this.computerOption.series[0].name = 'CPU使用率'
          break
        case '内存趋势':
          this.computerOption.color = ['#27be7f']
          this.computerOption.series[0].name = '内存趋势'
          break
        case '平均负荷趋势':
          this.computerOption.color = ['#ffc359']
          this.computerOption.series[0].name = '平均负荷趋势'
          break
        case 'IO速率趋势':
          this.computerOption.color = ['#c3c06c']
          this.computerOption.series[0].name = 'IO速率趋势'
          break
        default:
          break
      }
    },
    initOptions() {
      this.computerOption.xAxis.data = []
      this.computerOption.series = [
        {
          type: 'line',
          name: 'CPU趋势',
          data: [],
          showSymbol: true, // 隐藏拐点
        },
      ]
      this.computerOption.color = ['#44f1ff']
      this.computerOption.legend.show = true
      this.computerOption.grid.top = 30
      this.computerOption.yAxis.name = ''
      this.computerOption.legend.top = -20
    },
  },
  created() {
    this.initOptions()
  },
  components: { TableButtonGroup, CockpitDialog },
  props: {
    detailData: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    deviceType() {
      return get(this.detailData, 'deviceType') || ''
    },
    title() {
      return get(this.detailData, 'deviceName') || ''
    },
  },
  watch: {
    detailData: {
      handler(val) {
        if (val.deviceName === '服务器') {
          this.timeBtnList = this.$options.data().timeBtnList
          this.computerLabels = this.$options.data().computerLabels
        } else if (val.deviceName === '交换机') {
          this.timeBtnList.pop()
          this.computerLabels.pop()
        }
        if (val.deviceName === '定位基站') {
          const isJSONobj = isJSONObj(val.position)
          let position = {
            map_name: '',
            x: '',
            y: '',
          }
          if (isJSONobj) {
            position = JSON.parse(val.position)[0]
          }
          this.formData = {
            ...cloneDeep(val),
            status: val.status ? '在线' : '离线',
            position: `${position.map_name}(    x: ${position.x}, y: ${position.y}   )`,
          }
        } else {
          this.formData = cloneDeep(val)
        }
        const echartArr = ['computer', 'exchangeBoard']
        const isInclude = includes(echartArr, this.deviceType)
        if (isInclude) {
          this.getEchartsData(this.timeBtn)
        }
        if (val.deviceName === '机柜') {
          this.getCabinetData()
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>

<style scoped lang='scss'>
.pdt-table {
  ::v-deep .current-row {
    background: transparent !important;
  }
}
::v-deep .el-collapse {
  border-top: transparent;
  border-bottom: transparent;

  .el-collapse-item {
    margin-bottom: 5px;
  }

  .el-collapse-item__header {
    padding-left: 40px;
    height: 36px;
    color: #fff;
    background: #004655;
    line-height: 36px;
    position: relative;
    border-bottom: none;
    &::before {
      content: '\e791';
      position: absolute;
      left: 8px;
      top: 0;
      color: #d1e6ff;
      font-family: element-icons !important;
      font-size: 20px;
    }
  }
  .el-collapse-item__header.is-active {
    background: #0f6b73;
    font-weight: 700;
    &::before {
      content: '\e78f';
      font-weight: normal;
    }
  }
  .el-collapse-item__arrow.el-icon-arrow-right {
    display: none;
  }

  .el-collapse-item__wrap {
    color: #fff;
    background-color: transparent;
    border-bottom: transparent;
    padding: 5px 10px;
  }

  .el-collapse-item__content {
    padding: 0;
    color: #fff;
  }
}
</style>
